import React, { Fragment, useEffect, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import PageHeading from "Layout/AppMain/PageHeading";
import CustomFilter from "Components/ReactTable/Filters/CustomFilters";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { Link } from "react-router-dom";
import TextLimit from "Api/TextLimit";
import { iconSwitch } from "../utils";
import { useDownloadWeekstaatReport, useHistoryWeekstaat } from "Api/Melder/WeekReport/History";


const History = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [downloadId, setDownloadId] = useState(null);

  const {
    data: historyResponse,
    isLoading,
    error,
  } = useHistoryWeekstaat();

  const totalCount = historyResponse?.totalCount;

  const { data: downloadResponse, isLoading: downloadLoading } =
    useDownloadWeekstaatReport(downloadId);

  useEffect(() => {
    const weekstaatList = historyResponse?.weekstaat || [];

    if (weekstaatList.length > 0) {
      const formattedData = weekstaatList.map((element) => ({
        ...element,
        filterName: element.school,
        filterId: element.school_id,
      }));

      setData(formattedData);
      setFilterData(formattedData);

      const uniqueSchools = [
        ...new Map(
          formattedData.map((item) => [item.school_id, item])
        ).values(),
      ];

      setDropdownData(uniqueSchools);
    } else {
      setData([]);
      setFilterData([]);
      setDropdownData([]);
    }
  }, [historyResponse]);

  const handleSelect = (selectedValue) => {
    const updatedList = selectedValue
      ? filterData.filter((value) => value.school_id == selectedValue)
      : filterData;

    setData(updatedList);
  };

  const { data: downloadData } = useDownloadWeekstaatReport(downloadId);

  useEffect(() => {
    if (downloadData?.file?.download) {
      const link = document.createElement("a");
      link.href = downloadData.file.download;
      link.download = "weekstaat-report.pdf";
      link.click();
    }
  }, [downloadData]);

  const columns = useMemo(
    () => [
      {
        header: () => "ID",
        accessorKey: "id",
        cell: (value) => {
          return (
            <Link
              to={`/weekstaat/${value.row.original.id}`}
              key={value.row.original.id}
              state={{
                wsId: value.row.original.id,
                wid: value.row.original.wid,
                schoolId: value.row.original.school_id,
              }}
            >
              {value.row.original.id}
            </Link>
          );
        },
      },
      {
        header: () => "Organisatie",
        accessorKey: "organization",
        cell: (value) => {
          return window.innerWidth > 1250
            ? TextLimit.limitStringLargeScreen(
              value.row.original.organization
            )
            : TextLimit.limitStringSmallScreen(
              value.row.original.organization
            );
        },
      },
      {
        header: () => "School",
        accessorKey: "school",
        cell: (value) => {
          return window.innerWidth > 1250
            ? TextLimit.limitStringLargeScreen(value.row.original.school)
            : TextLimit.limitStringSmallScreen(value.row.original.school);
        },
      },
      {
        header: () => "Begindatum",
        accessorKey: "start_date",
      },
      {
        header: () => "Einddatum",
        accessorKey: "end_date",
      },
      {
        header: () => "Datum/tijd weekstaat",
        accessorKey: "created",
      },
      {
        header: () => "Status",
        accessorKey: "active",
        cell: (value) => {
          return iconSwitch(value.row.original.status);
        },
      },
      {
        header: () => "Actie",
        accessorKey: "pdf",
        cell: (value) =>
          value.row.original.filename ? (
            <a
              href="javascript:void(0)"
              onClick={() => setDownloadId(value.row.original.id)}
              className="anchor-action-link"
            >
              <div className="font-icon-wrapper download-button-style">
                <i className="pe-7s-download btn-icon-wrapper icon"> </i>
              </div>
            </a>
          ) : (
            ""
          ),
      },
    ],
    [downloadLoading]
  );

  return (
    <Fragment>
      <PageHeading />

      <TransitionOnLoad>
        <div>
          <Row>
            <Col md="12" lg="12">
              <Card className="main-card mb-3">
                <CardBody className="p-3">
                  <ReactTableGeneric
                    data={data}
                    columns={columns}
                    tableClassName="mb-0 table table-borderless table-sm table-hover"
                    count={totalCount}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </TransitionOnLoad>

      <div className="chat-layout-footer verzoken-footer-height">
        <CardFooter className="chat-layout-footer__inner gebruikers-footer">
          <CustomFilter data={dropdownData} handleCallback={handleSelect} />
        </CardFooter>


      </div>
    </Fragment>
  );
};

export default History;

